<ion-content class="page-wrapper">
  <div *ngIf="platformSRV.isNative.value" class="add-margin-top-to-safe-area"></div>

  <form class="page-min-height" [formGroup]="forgotPasswordForm">
  <ion-grid>
    <ion-row *ngIf="dataSRV.settings['global']">
      <ion-col sizeSm="10" offsetSm="1" sizeMd="8" offsetMd="2" sizeLg="6" offsetLg="3" style="text-align:center ;">
        <img class="logo-max" *ngIf="(dataSRV.settings['global']['default_logo_url'] | json)!='{}'"  [src]="dataSRV.settings['global']['default_logo_url']">
         
      </ion-col>
    </ion-row>
    <ion-row >
      <ion-col class="single-col-wider"
      >
      <ion-row>
        <ion-col style="text-align: center;">
          <h2 class="subheader-regular">{{('keys.data.users_login.forgot_password_title' | translate : {Default:'Forgot your Password?'}) || 'Forgot your Password?'}}</h2>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col style="text-align: center;">
          <ion-label class="paragraph-regular">{{('keys.data.users_login.forgot_password_line1' | translate : {Default:'Enter your email address below.'}) || 'Enter your email address below.'}}</ion-label>
          
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col style="text-align: center;">
          <ion-label class="paragraph-regular" [innerHTML]="('keys.data.users_login.forgot_password_line2' | translate) "></ion-label>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="ion-no-padding">
          <ion-card class="card-shadow-3">
            <ion-item>
              <ion-label position="stacked">{{('keys.data.users_login.email' | translate : {Default:'Email'}) || 'Email'}}:</ion-label>
              <ion-input
                required
                pattern="^[\w-\.]+@([\w-]+\.)+[\w-]{1,4}$"
                type="email"
                formControlName="email"
              ></ion-input>
            </ion-item>
          </ion-card>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="errors.length>0">
        <ion-col>
          <ion-card class="error_box card-shadow-3" >
            <ion-card-content >
              <ion-row>
              <ion-col class="ion-no-padding" style="text-align: center;"  *ngFor="let error of errors" size="12">
                <ion-label color="primary" class="card-text-bold">{{error}}</ion-label>
              </ion-col>
            </ion-row>
          </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
            <ion-button expand="block"
            [disabled]="!forgotPasswordForm.valid"
            color="primary"
            (click)="onSendReminder()"
          >
          {{('keys.data.users_login.send_reminder' | translate : {Default:'Send Reminder'}) || "Send Reminder"}}
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
            <ion-button expand="block"
            fill="outline"
            color="primary"
            routerLink="/login"
          >
          {{('keys.data.users_login.return_to_login' | translate : {Default:'Return to login page'}) || "Return to login page"}}
          </ion-button>
        </ion-col>
      </ion-row>
      
      </ion-col>
      </ion-row>
    
  </ion-grid>
  </form>
  <ion-footer class="ion-no-border">
    <app-footer></app-footer>
  </ion-footer>
</ion-content>
